import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ProductContextProvider from "./components/context/Context";

ReactDOM.render(
  <React.StrictMode>
    <ProductContextProvider>
      <App />
    </ProductContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
